/* Avelyn Club — onglets (clavier compris), barre qui glisse, fondu des panneaux.
   Sans JS, seul le premier panneau est visible : le HTML reste lisible. */
(function () {
  function init(root) {
    if (root.__lp) return;
    root.__lp = true;
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-panel]'));
    var bar = root.querySelector('.lp__tabs-bar');
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function moveBar(tab) {
      if (!bar || !tab) return;
      bar.style.setProperty('--bar-x', tab.offsetLeft + 'px');
      bar.style.setProperty('--bar-w', tab.offsetWidth);
    }

    function select(id, focus) {
      tabs.forEach(function (t) {
        var on = t.dataset.tab === id;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        if (on) {
          moveBar(t);
          if (focus) t.focus();
          if (t.scrollIntoView && t.parentElement.scrollWidth > t.parentElement.clientWidth) {
            t.scrollIntoView({ block: 'nearest', inline: 'center', behavior: reduced ? 'auto' : 'smooth' });
          }
        }
      });
      panels.forEach(function (p) {
        var on = p.dataset.panel === id;
        p.hidden = !on;
        p.classList.toggle('is-active', on);
        if (on && !reduced) {
          p.classList.add('is-entering');
          requestAnimationFrame(function () { requestAnimationFrame(function () { p.classList.remove('is-entering'); }); });
        }
      });
    }

    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(t.dataset.tab); });
      t.addEventListener('keydown', function (e) {
        var next = e.key === 'ArrowRight' ? i + 1 : e.key === 'ArrowLeft' ? i - 1 : null;
        if (next === null) return;
        e.preventDefault();
        select(tabs[(next + tabs.length) % tabs.length].dataset.tab, true);
      });
    });

    root.querySelectorAll('[data-count]').forEach(function (el) {
      el.textContent = new Intl.NumberFormat('fr-FR').format(Number(el.dataset.count) || 0);
    });

    // Lien direct vers un onglet : /pages/fidelite#paliers, #gagner, #recompenses, #faq
    var hashMap = { club: 'club', gagner: 'earn', recompenses: 'rewards', paliers: 'tiers', faq: 'faq' };
    var fromHash = hashMap[(location.hash || '').slice(1)];
    select(fromHash || 'club');
    window.addEventListener('resize', function () {
      moveBar(root.querySelector('[data-tab][aria-selected="true"]'));
    }, { passive: true });
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { moveBar(root.querySelector('[data-tab][aria-selected="true"]')); });
    }
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-club-tabs]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
